import React from 'react';
import { string, bool } from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import config from '../../config';
import { Form, Button, FieldTextInput } from '../../components';
import * as validators from '../../util/validators';
import { propTypes } from '../../util/types';


import css from './EndNegotiation.module.css';

const EndNegotiationComponent = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        inProgress,
        intl,
        listingTitle,
        authorDisplayName,
        values,
        invalid
      } = fieldRenderProps;

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitDisabled = submitInProgress || invalid;

      return (
        <Form className={classes} onSubmit={handleSubmit} enforcePagePreloadFor="OrderDetailsPage">

          <h2 className={css.heading}>
            Decline offer complete request
          </h2>

          <FieldTextInput
            id="desclineOfferDescription"
            name="declineOfferDescription"
            className={css.textField}
            type="textarea"
            label="Provide feedback"
            placeholder="Enter your feedback"
            validate={validators.required('You feedback is required')}
            isRequired
          />

          <br />

          <Button type="submit" inProgress={submitInProgress} disabled={submitDisabled}>
            Submit
          </Button>

        </Form>
      );
    }}
  />
);

EndNegotiationComponent.defaultProps = {
  rootClassName: null,
  className: null,
  submitButtonWrapperClassName: null,
  inProgress: false,
  sendEnquiryError: null,
};

EndNegotiationComponent.propTypes = {
  rootClassName: string,
  className: string,
  submitButtonWrapperClassName: string,

  inProgress: bool,

  listingTitle: string.isRequired,
  authorDisplayName: string.isRequired,
  sendEnquiryError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,
};

const EndNegotiation = compose(injectIntl)(EndNegotiationComponent);

EndNegotiation.displayName = 'EndNegotiation';

export default EndNegotiation;
